import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AccountState } from '../../accounts/store/account/account.entity';
import { AccountManagerService } from '../../api/managers/account-manager.service';
import { LocalCacheManager } from '../../api/managers/local-cache.manager';
import { LocationManagerService } from '../../api/managers/location-manager.service';
import { LoggingService } from '../../services/logging.service';
import { accountActionTypes } from './../../accounts/store/account/account.actions';

@Injectable()
export class LocationResolverService implements Resolve<void>
{

    constructor(private accountManager: AccountManagerService,
        private router: Router,
        private accountStore: Store<AccountState>,
        private localCacheManager: LocalCacheManager,
        private locationManager: LocationManagerService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void | Observable<void> | Promise<void> {

        // Inject the current location if it's missing and we know it.
        if (state.url === '/dashboard/irrigation/main' && this.locationManager.currentLocation) {
            this.router.navigate([`/dashboard/${this.locationManager.currentLocation.Id}/irrigation/main`]);
            return null;
        }
        else if (state.url === '/dashboard/lighting/scenes' && this.locationManager.currentLocation) {
            this.router.navigate([`/dashboard/${this.locationManager.currentLocation.Id}/lighting/scenes`]);
            return null;
        }
        else if (state.url === '/dashboard/lighting/themes' && this.locationManager.currentLocation) {
            this.router.navigate([`/dashboard/${this.locationManager.currentLocation.Id}/lighting/themes`]);
            return null;
        }
        else if (state.url === '/dashboard/firmware/' && this.locationManager.currentLocation) {
            this.router.navigate([`/dashboard/${this.locationManager.currentLocation.Id}/firmware/`]);
            return null;
        }

        LoggingService.log(state.url);
        if (state.url !== '/dashboard') {
            return null;
        }

        return this.accountManager.getAccountsList(false, true)
            .pipe(
                map(accountsList => {
                    this.accountStore.dispatch(accountActionTypes.LoadAccountsSuccess({ accounts: accountsList }));
                })
            );
    }

}
